import React from 'react';
import Icon from 'components/AppIcon';

export default function OpportunitiesStats({ stats }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {stats?.map((stat) => (
        <div
          key={stat?.label}
          className="rounded-xl p-4"
          style={{ background: 'var(--color-card)', border: '1px solid var(--color-border)' }}
        >
          <div className="flex items-center justify-between mb-3">
            <div
              className="flex items-center justify-center rounded-lg"
              style={{ width: 36, height: 36, background: stat?.bg }}
            >
              <Icon name={stat?.icon} size={16} color={stat?.color} />
            </div>
            {stat?.change != null && stat?.change !== '' && (
              <span
                className="font-caption text-xs font-semibold px-2 py-0.5 rounded-full"
                style={{ background: '#DCFCE7', color: '#15803D' }}
              >
                {stat?.change}
              </span>
            )}
          </div>
          <div className="font-heading font-bold text-xl" style={{ color: 'var(--color-foreground)' }}>
            {stat?.value}
          </div>
          <div className="font-caption text-xs mt-0.5" style={{ color: 'var(--color-text-secondary)' }}>
            {stat?.label}
          </div>
        </div>
      ))}
    </div>
  );
}
